export function localizeImage(path, english) {
    return english && typeof path === 'string'
        ? path.replace(/lizingSespelFinance\.webp$/, 'lizingSespelFinance.en.png')
        : path;
}
